<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :custom-label="labelSelect"
    :options="options"
    selectLabel=""
    selectedLabel=""
    deselectLabel=""
    :allowEmpty="false"
    :preselectFirst="true"
    :loading="isLoading || loading"
    :label="$t('Nome')"
    track-by="id"
    :disabled="isDisabled"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado') }}.</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado') }}.</span>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: ['nameField', 'isRequired', 'isDisabled', 'includeAll', 'returnName', 'isObject', 'loading'],

  data() {
    return {
      selected: '',
      isLoading: false
    };
  },

  computed: {
    options() {
      return [
        { id: null, nome: this.$t('Todos os Saldos') },
        { id: true, nome: this.$t('Apenas Positivos') },
        { id: false, nome: this.$t('Apenas Negativos') }
      ];
    }
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', this.returnName, null);
        return;
      }
      this.isObject
        ? this.$emit('selectChange', this.returnName, e)
        : this.$emit('selectChange', this.returnName, e.id);

      this.$emit('focus');
    },
    labelSelect({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (value != null) {
        if (value.id) {
          this.selected = this.options.find((option) => String(option.id) === String(value.id));
        } else {
          this.selected = this.options.find((option) => String(option.id) === String(value));
        }
      } else {
        this.selected = this.options.find((option) => option.id === null);
      }
      this.$emit('input', this.selected);
    }
  },
  created() {
    this.setValue(this.nameField);
  },
  watch: {
    data: function (value) {
      if (value.length > 0) {
        this.setValue(this.nameField);
      }
    },
    nameField: function (value) {
      this.setValue(value);
    }
  }
};
</script>
